import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react/enhancers';
import { compose } from '@beef/utils';
import { HomeServices } from '@beef/elk-common';
import { selectConvergentAccumulators } from "../../Mobile/store";
var mapStateToProps = function mapStateToProps(state) {
  return {
    items: selectConvergentAccumulators(state),
    shouldRender: !!selectConvergentAccumulators(state),
    isMobile: true
  };
};
export var ConvergentAccumulators = compose(connect(mapStateToProps), withRenderFlag)(HomeServices);